export default __webpack_public_path__ + "static/media/coin.5056fef7.png";